module.exports = __webpack_public_path__ + "static/media/forTravelingSitters.a706b8f2.jpg";